import { render, staticRenderFns } from "./CrmSales.vue?vue&type=template&id=44027d6e&scoped=true"
import script from "./CrmSales.vue?vue&type=script&lang=js"
export * from "./CrmSales.vue?vue&type=script&lang=js"
import style0 from "./CrmSales.vue?vue&type=style&index=0&id=44027d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44027d6e",
  null
  
)

export default component.exports